import React, { useEffect, useRef, useState } from "react";
import { Music } from "lucide-react";

import { TruncatedTitle } from "../common/Primitives";


export default function SongCard({ task, onClick, showTypeLabel, inAllTab }) {
  const [countdown, setCountdown] = useState(30);
  const [timerExpired, setTimerExpired] = useState(false);
  const createdAtRef = useRef(task.created_at ? new Date(task.created_at).getTime() : Date.now());

  const isPending = task.status === 'pending' || task.status === 'processing';
  const isStreaming = task.status === 'streaming';
  const isCompleted = task.status === 'completed';
  const isPlayable = isCompleted || isStreaming;
  const hasImage = !!task.image_url;

  const subtitle = task.mode === 'prompt'
    ? (task.gpt_description_prompt || task.prompt)?.slice(0, 50)
    : task.style;

  useEffect(() => {
    if (!isPending) return;
    const startTime = createdAtRef.current;
    const timer = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = Math.max(0, 30 - elapsed);
      setCountdown(remaining);
      if (remaining === 0) setTimerExpired(true);
    }, 1000);
    return () => clearInterval(timer);
  }, [isPending]);

  const formatTime = (secs) => {
    const mins = Math.floor(secs / 60);
    const s = secs % 60;
    return `${mins}:${s.toString().padStart(2, '0')}`;
  };

  return (
    <div
      className={`library-card library-card-song ${isPlayable ? 'library-card-clickable' : ''}`}
      onClick={isPlayable ? onClick : undefined}
      data-testid={`music-task-${task.id}`}
    >
      <div className="library-card-cover">
        {hasImage ? (
          <img
            src={task.image_url}
            alt={task.title}
            className="library-card-image"
            onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
          />
        ) : null}
        <div className="library-card-icon-song" style={{ display: hasImage ? 'none' : 'flex' }}>
          <Music size={24} />
        </div>
      </div>

      <div className="library-card-content">
        <TruncatedTitle title={task.title} />
        <div className="library-card-subtitle subtle truncate-line">
          {inAllTab && <span className="type-label type-song">Song</span>}
          {isCompleted ? (
            <span>{task.style || 'Unknown genre'}</span>
          ) : isStreaming ? (
            <span className="text-accent">▶ Ready to play</span>
          ) : task.status === 'failed' ? (
            <span className="text-red">Failed</span>
          ) : subtitle ? (
            <span>{subtitle}</span>
          ) : null}
        </div>
      </div>

      {isPending && (
        <div className="library-card-status">
          {timerExpired ? (
            <span className="spinner" />
          ) : (
            <div className="song-timer">{formatTime(countdown)}</div>
          )}
        </div>
      )}
    </div>
  );
}
